import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import NavBar from "@/components/site/NavBar";
import Hero from "@/components/site/Hero";
import Ecosystem from "@/components/site/Ecosystem";
import Ethos from "@/components/site/Ethos";
import ClientWork from "@/components/site/ClientWork";
import Faq from "@/components/site/Faq";
import Connect from "@/components/site/Connect";
import Footer from "@/components/site/Footer";

export default function Landing() {
  const location = useLocation();
  const scrollTo = location.state?.scrollTo;

  // Arriving from a policy page via a nav link: scroll to the section the user
  // actually asked for, once it exists.
  useEffect(() => {
    if (!scrollTo) return;
    const el = document.getElementById(scrollTo);
    if (!el) return;
    window.scrollTo({
      top: el.getBoundingClientRect().top + window.scrollY - 80,
      behavior: "smooth",
    });
  }, [scrollTo]);

  return (
    <div
      data-testid="landing-page"
      className="relative min-h-screen bg-surface-0 text-[#F8FAFC] selection:bg-[#10B981]/30"
    >
      <NavBar />
      <main>
        <Hero />
        <Ecosystem />
        <Ethos />
        <ClientWork />
        <Faq />
        <Connect />
      </main>
      <Footer />
    </div>
  );
}
